import { Box, Stack, Pagination as MUIPagination } from '@mui/material'
import { color } from 'config/color'

interface IPagination {
  count: number
  page: number
  onChange: (_e: any, value: any) => void
}

export const Pagination = ({
  count,
  page,
  onChange
}: IPagination): JSX.Element => {
  return (
    <Box display="flex" justifyContent="space-around">
      <Stack spacing={2}>
        <MUIPagination
          count={count}
          page={page}
          onChange={onChange}
          showFirstButton
          showLastButton
          sx={{
            '.Mui-selected ': {
              bgcolor: `${color.primary[600]} !important`,
              color: color.white,
              borderRadius: '20%'
            }
          }}
        />
      </Stack>
    </Box>
  )
}
